import { createContext, useEffect, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import MaskTransition, {
  MaskTransitionHandler
} from '@/contexts/transition/components/MaskTransition'
import { useLoaderStore } from '@/store/loader'

export const TransitionContext = createContext<undefined>(undefined)

const TransitionProvider = () => {
  const nodeRef = useRef<HTMLElement>(null!)
  const maskRef = useRef<MaskTransitionHandler>(null!)
  // const setLoaderState = useLoaderStore((state) => state.setState)

  const { contextSafe } = useGSAP({ scope: nodeRef })

  const handleEnterTransition = contextSafe(() => {
    document.documentElement.classList.remove('page-transition')
    return requestAnimationFrame(() => {
      if (!useLoaderStore.getState().pageLoaded) return
      gsap.timeline().add(maskRef.current?.leaveTimeline())
    })
  })

  // const handleLeaveTransition = contextSafe(() => {
  //   document.documentElement.classList.add('page-transition')
  //   setLoaderState({ pageLoaded: false })
  //   gsap.timeline().add(maskRef.current?.enterTimeline())
  // })

  useEffect(() => {
    if (maskRef.current) handleEnterTransition()
  }, [])

  return <MaskTransition ref={maskRef} />
}

export default TransitionProvider
